(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9946],{

/***/ 9634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _src_components_Shared_BreadCrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5467);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6896);
/* harmony import */ var _styles_projects_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6154);
/* harmony import */ var _styles_projects_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_projects_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _src_components_Home_Categories__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9052);
/* harmony import */ var _src_components_Shared_Next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6543);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);








var ProjectsPage = function ProjectsPage(_ref) {
  var _seoData$title, _seoData$title2, _seoData$description, _seoData$keywords, _personnelData$descri, _personnelData$descri2, _personnelData$descri3, _personnelData$descri4, _personnelData$descri5, _personnelData$descri6;

  var personnelData = _ref.personnelData,
      seoData = _ref.seoData;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_styles_projects_module_scss__WEBPACK_IMPORTED_MODULE_5___default().projectsPage),
    children: [(seoData === null || seoData === void 0 ? void 0 : (_seoData$title = seoData.title) === null || _seoData$title === void 0 ? void 0 : _seoData$title[locale]) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_src_components_Shared_Next_seo__WEBPACK_IMPORTED_MODULE_2__["default"], {
      title: seoData === null || seoData === void 0 ? void 0 : (_seoData$title2 = seoData.title) === null || _seoData$title2 === void 0 ? void 0 : _seoData$title2[locale],
      description: seoData === null || seoData === void 0 ? void 0 : (_seoData$description = seoData.description) === null || _seoData$description === void 0 ? void 0 : _seoData$description[locale],
      keywords: seoData === null || seoData === void 0 ? void 0 : (_seoData$keywords = seoData.keywords) === null || _seoData$keywords === void 0 ? void 0 : _seoData$keywords[locale]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_src_components_Shared_BreadCrumbs__WEBPACK_IMPORTED_MODULE_0__["default"], {
      heading: formatMessage({
        id: "personnel"
      }),
      description: "".concat(formatMessage({
        id: "main"
      }), " / ").concat(formatMessage({
        id: "personnel"
      })),
      background: personnelData === null || personnelData === void 0 ? void 0 : personnelData.breadCurmbImage
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "row",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "details text-center py-5",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
            children: personnelData === null || personnelData === void 0 ? void 0 : (_personnelData$descri = personnelData.description) === null || _personnelData$descri === void 0 ? void 0 : (_personnelData$descri2 = _personnelData$descri[0]) === null || _personnelData$descri2 === void 0 ? void 0 : (_personnelData$descri3 = _personnelData$descri2.secTitle) === null || _personnelData$descri3 === void 0 ? void 0 : _personnelData$descri3[locale]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "desc",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              dangerouslySetInnerHTML: {
                __html: personnelData === null || personnelData === void 0 ? void 0 : (_personnelData$descri4 = personnelData.description) === null || _personnelData$descri4 === void 0 ? void 0 : (_personnelData$descri5 = _personnelData$descri4[0]) === null || _personnelData$descri5 === void 0 ? void 0 : (_personnelData$descri6 = _personnelData$descri5.description) === null || _personnelData$descri6 === void 0 ? void 0 : _personnelData$descri6[locale]
              }
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "projects-body swiper",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_src_components_Home_Categories__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        data: personnelData,
        page: "categories"
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ProjectsPage);

/***/ }),

/***/ 223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personnel",
      function () {
        return __webpack_require__(9634);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8166,4577,2962,2143,1664,3053,5836,4398,696,8160,9774,2888,179], function() { return __webpack_exec__(223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);